// extracted by mini-css-extract-plugin
module.exports = {"star":"Star_star__R3G0f"};